import { eq } from "drizzle-orm";
import { type PowerSyncDrizzleDB, user } from "@space/powersync";
import { VISITOR_ID } from "../constants/common";

/**
 * Shared Drizzle mutation for updating User locale.
 */
export async function updateUserLocaleMutation(
  db: PowerSyncDrizzleDB,
  userId: string,
  locale: string,
): Promise<void> {
  const query = db.update(user).set({ locale });
  await (userId === VISITOR_ID ? query : query.where(eq(user.id, userId)));
}

/**
 * Shared Drizzle mutation for updating User font family preference.
 */
export async function updateUserFontFamilyMutation(
  db: PowerSyncDrizzleDB,
  userId: string,
  fontFamilyId: string | null,
): Promise<void> {
  await db.update(user).set({ font_family: fontFamilyId }).where(eq(user.id, userId));
}

/**
 * Shared Drizzle mutation for updating global theme.
 */
export async function updateGlobalThemeMutation(
  db: PowerSyncDrizzleDB,
  userId: string,
  themeId: string | null,
): Promise<void> {
  const query = db.update(user).set({ global_theme_id: themeId });
  await (userId === VISITOR_ID ? query : query.where(eq(user.id, userId)));
}

/**
 * Shared Drizzle mutation for updating blur effect preference.
 */
export async function updateBlurMutation(
  db: PowerSyncDrizzleDB,
  userId: string,
  isBlur: boolean,
): Promise<void> {
  const query = db.update(user).set({ is_blur: isBlur ? 1 : 0 });
  await (userId === VISITOR_ID ? query : query.where(eq(user.id, userId)));
}

/**
 * Shared Drizzle mutation for updating follow device appearance preference.
 */
export async function updateFollowDeviceThemeMutation(
  db: PowerSyncDrizzleDB,
  userId: string,
  followDevice: boolean,
): Promise<void> {
  const query = db.update(user).set({ follow_device_theme: followDevice ? 1 : 0 });
  await (userId === VISITOR_ID ? query : query.where(eq(user.id, userId)));
}

/**
 * Consentimiento de aparición en leaderboards (opt-in de privacidad).
 *
 * Escribe `user.leaderboard_opt_in` local-first; el write-path del servidor
 * reconcilia las entradas de leaderboard del usuario (opt-out las oculta del
 * stream de otros; opt-in las publica con su XP actual). Server-authoritative:
 * el cliente jamás escribe `leaderboard_entry` directamente.
 */
export async function updateLeaderboardOptInMutation(
  db: PowerSyncDrizzleDB,
  userId: string,
  optIn: boolean,
): Promise<void> {
  await db
    .update(user)
    .set({ leaderboard_opt_in: optIn ? 1 : 0 })
    .where(eq(user.id, userId));
}
